import { AbstractPmsApiService } from "./abstract.service";

export class AuthPasswordPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/auth/password';
    }

    /**
     * @param {string} email
     * @return {Promise.<boolean>}
     */
    request(email) {

        const url = this.url();

        return this.http
                   .post(url, {email}, {headers: this.headers})
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {{token: string, password: string, password_confirmation: string}} credentials
     * @return {Promise.<boolean>}
     */
    restore(credentials) {

        const url = this.url();

        return this.http
                   .put(url, credentials, {headers: this.headers})
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    email(token, name = null) {
        
        const url = this.url();
        const params = {token: token};
        if(name !== null)
            params.with = name;
        
        return this.http
                   .get(url, {headers: this.headers, params})
                   .then(this.getDataExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/auth-password.service.js